import { Metrics } from 'src/utils';
import { MethodName, MetricKeys } from 'src/constants/metrics';

const clickMetric = (pageName: string, metricKey: string, metricValue: string): void => {
  const metrics = new Metrics(`${MethodName.userClick}.${pageName}`);
  metrics.publishString(metricKey, metricValue);
  metrics.publishCounterMetric(MetricKeys.click, 1);
};

export default clickMetric;
